import { fromPServedUser } from '@/shared/utils/uri'

const isHexRoomGuid = (value: string): boolean => /^[A-F0-9]+$/i.test(value)

export const resolvePrepareToCallRoomId = (roomIdParam: string): string => {
  if (!roomIdParam) {
    return roomIdParam
  }

  if (roomIdParam.includes('<sip:')) {
    return fromPServedUser(roomIdParam)
  }

  if (isHexRoomGuid(roomIdParam)) {
    return roomIdParam
  }

  try {
    const decoded = atob(roomIdParam)
    if (isHexRoomGuid(decoded)) {
      return decoded
    }
  } catch {
    // not base64
  }

  return roomIdParam
}
